import * as types from '../const/action.types';

export function manageFormHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.MANAGE_FORM_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function manageFormIsLoading(state = false, action) {
    switch (action.type) {
        case types.MANAGE_FORM_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function manageFormIsSaving(state = false, action) {
    switch (action.type) {
        case types.MANAGE_FORM_IS_SAVING:
            return action.isSaving;
        default:
            return state;
    }
}

export function manage_form(state = {}, action) {
    switch (action.type) {
        case types.MANAGE_FORM_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.manage.form.reducer.js